import { useQuery } from '@tanstack/react-query';

import { AdvertisementsApiParams, AdvertisementsApiResponse } from '../types';

import { clientAxios } from '@/shared/api';
import { ApiResponse } from '@/shared/types';

const useAdvertisementsQuery = ({ location }: AdvertisementsApiParams) => {
  return useQuery({
    queryKey: ['advertisementsApi', location],
    queryFn: async () => {
      const { data } = await clientAxios.get<
        ApiResponse<AdvertisementsApiResponse>
      >('/advertisementsApi/', { params: { location } });

      const {
        id,
        target_link,
        image,
        web_main_text,
        web_sub_text,
        mobile_main_text,
      } = data.data;

      return {
        id,
        link: target_link,
        imgSrc: image,
        mainDescription: web_main_text,
        subDescription: web_sub_text,
        mobileDescription: mobile_main_text,
      };
    },
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    gcTime: 0,
  });
};

export default useAdvertisementsQuery;
